import Vue from 'vue'
import Vuex from 'vuex'
import modules from './modules';
import createPersistedState from 'vuex-persistedstate'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: modules,
  strict: true,
  // リロードしてもstoreの値を保持する（ログインの永続化）
  // paths内に記載したstateはsessionStorageに保存する
  plugins: [createPersistedState({
      key: 'ShingakushaEpro',
      paths: ['user', 'master', 'school', 'account', 'top', 'sheet'],
      storage: window.sessionStorage
  })],

  state: {
    currentPath: '',
    drawer: false,
  },

  mutations: {
    setCurrentPath(state, payload) {
      state.currentPath = payload.path;
    },
    setDrawer(state, payload) {
      state.drawer = payload.drawer;
    },
  },
})
